exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stats-card .stats-item{display:inline-block}.stats-card .stats-item .stats-text{margin-bottom:.285rem;padding-right:10px}.stats-card .stats-item .stats-val{padding-right:10px}.stats-card .stats-item .stats-sub-text{margin-top:.571rem}\n", ""]);

// exports
